import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'

import { ActivatedRoute, Router } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { take } from 'rxjs'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { AppSignals, CommonService } from '@appShared/services'
import { UrlService } from '@appShared/services/url.service'
import { ContentRegistrationProgressesService } from '@appShared/services/content-registration-progresses.service'
import { ContentRegistrationsService } from '@appShared/services/content-registrations.service'
//import { HybridWebviewInteropService } from '@appShared/services/hybrid-webview-interop.service'
import { AppFacade } from '@appShared/services/app.facade'
import { IUser } from '@appShared/interfaces/[Interface-based]/user.interface'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-iframe-player',
    templateUrl: './iframe-player.component.html',
    styles: [`
      .exit-button {
         font-size:11px;
         opacity:.75;
         padding-top:3px;
         padding-bottom:1px;
      }
   `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class IFramePlayerComponent implements OnInit {
   @ViewChild('iframe') iframe: ElementRef
   @Input() frameSourceInput: string

   private _urlService = inject(UrlService)
   private _router = inject(Router)
   private _activatedRoute = inject(ActivatedRoute)
   private _contentRegistrationProgressesService = inject(ContentRegistrationProgressesService)
   //private _hybridWebviewInteropService = inject(HybridWebviewInteropService)
   private _modalService = inject(NgbModal)
   private _titleService = inject(Title)

   private _contentRootUri = `/${SITE_DIRECTORY_ROUTES.content.uri}`
   //private _coursesUri = `/${SITE_DIRECTORY_ROUTES.content.uri}`
   private _modalRef: NgbModalRef
   token: string
   iframeSrc: string
   @ViewChild('modaltemplate') modalTemplate: TemplateRef<Element>

   private _user = inject(AppSignals).currentUser

   constructor(
   ) {
      this._titleService.setTitle(SITE_DIRECTORY_ROUTES.title)
   }

   //https%3A%2F%2Fsite-68952654.bcvp0rtal.com
   ngOnInit() {
      this.token = this._activatedRoute.snapshot.queryParamMap.get('token')

      if (this.token) {

         //this._contentRegistrationsService.getCourseLink(this.token)
         //   .then(registration => {
         //      this._setCourseUri(registration.launchLink)
         //   })
         //   .catch(() => {
         //      this._router.navigate([this._coursesUri])
         //   })
      } else {
         const src = this.frameSourceInput || this._activatedRoute.snapshot.queryParamMap.get('src')

         if (src) {
            this._setCourseUri(decodeURIComponent(src))
         } else {
            this._router.navigate([this._contentRootUri])
         }
      }

      setTimeout(() => { this._urlService.setHeaderTitle('') })
   }

   /*
   * private methods
   * */

   private _setCourseUri(courseUri: string) {
      setTimeout(() => {
         if (this.iframe && courseUri) {
            this.iframe.nativeElement.src = courseUri
         }
      }, 0)

   }

   /*
   * public methods
   * */

   onIFrameLoad(iframe?: HTMLIFrameElement) {
      this.iframeSrc = iframe?.src
   }

   exitCourse() {

      this._modalRef = this._modalService.open(this.modalTemplate, { backdrop: 'static' })

      let closeAndNavigate = () => {
         //this._hybridWebviewInteropService.relayActivity(this._user()?.profile.contact, this._hybridWebviewInteropService.relayedActivityType?.moduleExit)
         this._modalRef.dismiss()
         this._router.navigate([this._contentRootUri])
      }

      if (this.token) {

         this._contentRegistrationProgressesService.updateProgressRegistration(this.token)
            /* no matter what we get back - close and navigate */
            .finally(() => {
               closeAndNavigate()
            })

      } else {
         /* somehow no token? close and navigate */
         closeAndNavigate()
      }
   }
}
